import DomainSelect from 'volta/components/domain-select';
import JsonApiInfinityModel, { decorateApiQuery } from 'volta/models/jsonapi-infinity-model';
import Warehouse, { WarehouseResourceName } from 'volta/models/warehouse';
import { inFilter, lkFilter, niFilter } from 'volta/utils/filters-utils';

import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export default class WarehouseSelect extends DomainSelect<Warehouse, {}> {
  get infiniteScroll() {
    return true;
  }

  get idKey() {
    return 'id';
  }

  async searchPromise({ search, selected, excluded }: Record<string, any>) {
    const query: IJsonApiQuery = {
      sort: 'description,code'
    };
    const filter: IJsonApiQuery['filter'] = {};

    if (search && search.length) {
      filter['q'] = lkFilter(search);
    }
    if (selected && selected.length) {
      filter['selectedIds'] = inFilter(selected);
    } else if (excluded && excluded.length) {
      // This case should happen only when selected is empty
      filter['excludedIds'] = niFilter(excluded);
    }
    query.filter = filter;

    const decoratedQuery = this.args.beforeQuery?.(query) ?? query;

    return await this.infinity.model(
      WarehouseResourceName.singular,
      decorateApiQuery(decoratedQuery),
      JsonApiInfinityModel
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    WarehouseSelect: typeof WarehouseSelect;
    'warehouse-select': typeof WarehouseSelect;
  }
}
